import { render, staticRenderFns } from "./ProfileDetail.vue?vue&type=template&id=0d0a2d00&"
import script from "./ProfileDetail.vue?vue&type=script&lang=js&"
export * from "./ProfileDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/Users/jurajpetras/dev/pmat/web/frontend/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BTh, BTd, BTr, BBadge, BTbody, BTableSimple, BButton, BCol, BRow, BContainer} from 'bootstrap-vue'
    installComponents(component, {BTh, BTd, BTr, BBadge, BTbody, BTableSimple, BButton, BCol, BRow, BContainer})
    

export default component.exports